"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var st_1 = require("../st");
exports.BUS_INIT_NAME = "$st__bus";
exports.BUS_TOPIC_WILDCARD = '*';
// for st.enable(bus, ...)
exports.bus = null;
if (!st_1.st.bus) {
    st_1.st.bus = {
        init: function (instance) {
            if (instance === void 0) { instance = st_1.st; }
            if (!instance[exports.BUS_INIT_NAME]) {
                instance[exports.BUS_INIT_NAME] = {
                    listeners: []
                };
            }
        },
        sendMessage: function (topic, data, instance) {
            if (instance === void 0) { instance = st_1.st; }
            st_1.st.bus.init(instance);
            for (var _i = 0, _a = instance[exports.BUS_INIT_NAME].listeners; _i < _a.length; _i++) {
                var observer = _a[_i];
                if (observer && (observer.topic === topic || observer.topic === exports.BUS_TOPIC_WILDCARD)) {
                    observer.fn(data, topic);
                }
            }
        },
        onMessage: function (topic, fn, instance) {
            if (instance === void 0) { instance = st_1.st; }
            st_1.st.bus.init(instance);
            instance[exports.BUS_INIT_NAME].listeners.push({
                topic: topic,
                fn: fn
            });
        },
        onMessageUnsubscribe: function (topic, fn, instance) {
            if (instance === void 0) { instance = st_1.st; }
            if (!instance[exports.BUS_INIT_NAME])
                return;
            for (var i = 0; i < instance[exports.BUS_INIT_NAME].listeners.length; i++) {
                var observer = instance[exports.BUS_INIT_NAME].listeners[i];
                if (fn && fn === observer && (observer.topic === topic || topic === exports.BUS_TOPIC_WILDCARD)) {
                    delete instance[exports.BUS_INIT_NAME].listeners[i];
                }
            }
        }
    };
    st_1.st.sendMessage = st_1.st.bus.sendMessage;
    st_1.st.onMessage = st_1.st.bus.onMessage;
    st_1.st.onMessageUnsubscribe = st_1.st.bus.onMessageUnsubscribe;
}
else {
    if (process.env.NODE_ENV === 'development') {
        st_1.st.warn('Module event-bus is loaded twice. Check for duplicate famework import!');
    }
}
//# sourceMappingURL=event-bus.js.map